import React from 'react';
import './Sidebar.css';

function Sidebar({ variables = {}, onPhraseSelect, viewingPhraseIndex = 0, onRestart, onExit, isOpen = false, onClose }) {
  const situation = variables.situation || '';
  const currentPhraseIndex = variables.currentPhraseIndex || 0;
  const phrase = variables.phrase || [];
  const answer = variables.answer || [];
  
  // Определяем количество фраз
  const phraseCount = Math.max(
    Array.isArray(phrase) ? phrase.length : 0,
    Array.isArray(answer) ? answer.length : 0,
    currentPhraseIndex + 1
  );

  // Получаем все фразы и ответы для всех индексов
  // Показываем только важные переменные: phrase и answer
  const getAllPhraseAnswers = () => {
    const allAnswers = [];
    
    // Проходим по всем возможным индексам фраз
    for (let i = 0; i < phraseCount; i++) {
      if (Array.isArray(phrase) && phrase[i]) {
        allAnswers.push({ type: 'phrase', value: phrase[i], phraseIndex: i });
      }
      if (Array.isArray(answer) && answer[i]) {
        allAnswers.push({ type: 'answer', value: answer[i], phraseIndex: i });
      }
    }
    
    return allAnswers;
  };

  const allAnswers = getAllPhraseAnswers();

  return (
    <div className={`sidebar ${isOpen ? 'sidebar-open' : ''}`}>
      {/* Кнопка закрытия для мобильных устройств */}
      {onClose && (
        <button className="sidebar-close-button" onClick={onClose} aria-label="Закрыть меню">
        </button>
      )}
      <div className="sidebar-content">
        {/* Логотип */}
        <div className="sidebar-logo">
          <img 
            src="https://static.tildacdn.com/tild6363-3066-4739-a533-316439323439/logo.svg" 
            alt="Soft Skills Lab" 
            className="logo-img"
          />
        </div>

        {/* Название */}
        <h2 className="sidebar-title">Система конфликта Soft Skills Lab</h2>

        {/* Ситуация */}
        {situation && (
          <div className="sidebar-section">
            <h3 className="sidebar-section-title">Ситуация</h3>
            <p className="sidebar-text">{situation}</p>
          </div>
        )}

        {/* Диалог всех фраз */}
        {allAnswers.length > 0 && (
          <div className="sidebar-section">
            <h3 className="sidebar-section-title">Диалог</h3>
            <div className="sidebar-dialog">
              {allAnswers.map((item, idx) => {
                return (
                  <div key={idx} className={`dialog-item ${item.type === 'phrase' ? 'phrase' : 'answer'}`}>
                    <div className="dialog-label">
                      {item.type === 'phrase' ? `Фраза ${item.phraseIndex + 1}:` : `Ответ ${item.phraseIndex + 1}:`}
                    </div>
                    <div className="dialog-value">{String(item.value)}</div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Кнопки управления */}
        {(onRestart || onExit) && (
          <div className="sidebar-section sidebar-skip-section">
            <div className="sidebar-buttons-container">
              {onRestart && (
                <button className="sidebar-skip-button" onClick={onRestart}>
                  Начать заново
                </button>
              )}
              {onExit && (
                <button className="sidebar-exit-button" onClick={onExit}>
                  Выйти
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Sidebar;

